import Vue from 'vue'
import App from '@/App.vue'
import { router } from '@/router'
import store from '@/store'
import '@/service-worker'
import camelCase from 'lodash/camelCase'
import VueTippy from 'vue-tippy'
import VueClipboards from 'vue-clipboards'
import Breakpoints from '@/directives/Breakpoints'
import Collapse from '@/directives/Collapse'
import Notice from '@/directives/Notice'
import BEM from '@/directives/BEM'
import Scrollbar from '@/directives/Scrollbar'
import { isElectron } from '@/util/Helpers'
import * as Sentry from '@sentry/browser'
import * as SentryIntegrations from '@sentry/integrations'
import '@fortawesome/fontawesome-pro/css/all.min.css'
import 'perfect-scrollbar/css/perfect-scrollbar.css'
import PStorage, { EMAIL, USERNAME, SEND_CRASH_REPORTS, SEND_CRASH_FEEDBACK } from './util/PStorage'
import './data/db-store'

// Global component registration
// @see https://vuejs.org/v2/guide/components-registration.html#Automatic-Global-Registration-of-Base-Components
const requireComponent = require.context('@/components/common', false)
requireComponent.keys().forEach((fileName: string) => {
    const componentConfig = requireComponent(fileName)
    const componentName = camelCase(fileName.replace(/^\.\/(.*)\.\w+$/, '$1'))
    Vue.component(componentName, componentConfig.default || componentConfig)
})

Vue.config.productionTip = false

Vue.use(VueTippy)
Vue.use(VueClipboards)
Vue.use(Notice)
Vue.directive('breakpoints', Breakpoints)
Vue.directive('collapse', Collapse)
Vue.directive('bem', BEM)
Vue.directive('scroll', Scrollbar)

if (PStorage.getOrDefault(SEND_CRASH_REPORTS, process.env.NODE_ENV !== 'development')) {
    Sentry.init({
        dsn: 'https://7eeef528763940b78bdd2088c55ae2b7@sentry.io/1506983',
        integrations: [new SentryIntegrations.Vue({ Vue, attachProps: false })],
        beforeSend(event, hint) {
            if (event.exception && PStorage.getOrDefault(SEND_CRASH_FEEDBACK, true)) {
                Sentry.showReportDialog({
                    eventId: event.event_id,
                    user: {
                        email: PStorage.get(EMAIL),
                        name: PStorage.get(USERNAME)
                    },
                    title: 'Something went wrong :(',
                    subtitle: 'An error was thrown on this page.'
                })
            }
            return event
        }
    })
}

// Vue.config.warnHandler = (err, vm, info) =>
//     Vue.config.errorHandler(new Error(err), vm, info)

export const main = new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')

// init electron if available
if (isElectron()) {
    // eslint-disable-next-line
    require('./electron/renderer').default(main)
    window.ipc = require('electron').ipcRenderer
}
